/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react";
import { Provider } from "react-redux";
import createStore from './src/state/createStore';
import './src/styles/bootstrap/bootstrap.scss';
import { config } from '@fortawesome/fontawesome-svg-core';

// Disable the automatic insertion 
// of CSS into the head of the document.
config.autoAddCss = false;

export const wrapRootElement = ({ element }) => {
  const store = createStore();

  return <Provider store={store}>{element}</Provider>
};